export const POST_SIGN_IN = 'users/login';
export const GET_USER_DATA = 'auditors/me';
export const GET_DATA_FLOWS = 'candidate-data-flow';
export const GET_DATA_FLOW_BY_ID = 'candidate-data-flow';
export const GET_CANDIDATE_DATA_FLOW = 'candidate-data-flow';
export const UPDATE_DATA_FLOW = 'candidate-data-flow/update-data-flow';
export const ADD_DATA_FLOW_MESSAGE = 'candidate-data-flow/messages';
export const REQUEST_DOCUMENT = 'candidate-data-flow/request-document';
export const UPLOAD_FILE = 'upload';
export const ADD_LICENSE_SUBMISSION = 'candidate-data-flow/add-license-submission';
export const ADD_EXAM_BOOKING = 'candidate-data-flow/add-exam-booking';
export const UPDATE_EXAM_BOOKING_STATUS = 'candidate-data-flow/update-exam-booking-status';
export const MARK_REQUEST_DOCUMENT_AS_UPLOADED = 'candidate-data-flow/mark-request-document-as-uploaded';